import { Suspense } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { LogOut, Users } from 'lucide-react';
import { useAuth, usePortal } from './AuthProvider';
import { HomeButton } from './HomeButton';
import { Logo } from './Brand';
import { Spinner } from '../ui/components';

/** The portal's own shell (D83): a single bar over the home screen, People, and Documents. The scheduler brings its own. */
export function PortalShell() {
  const { member, org, portalAdmin } = usePortal();
  const { signOut } = useAuth();
  const { pathname } = useLocation();
  return (
    <div className="flex h-full flex-col">
      <header className="flex h-14 shrink-0 items-center gap-3 border-b-2 border-gold bg-navy px-4 text-white">
        {pathname !== '/' && <HomeButton dark />}
        <Link to="/" className="flex min-w-0 items-center gap-3" title={org.name}>
          <Logo onNavy className="h-6 sm:h-7" />
          <span className="hidden border-l border-white/30 pl-3 text-xs uppercase tracking-[0.14em] text-white/80 sm:inline">Portal</span>
        </Link>
        <div className="flex-1" />
        {portalAdmin && (
          <NavLink to="/people" className={({ isActive }) => `flex items-center gap-1.5 rounded px-2.5 py-1.5 text-sm ${isActive ? 'bg-white/15 font-semibold' : 'text-white/80 hover:bg-white/10 hover:text-white'}`}>
            <Users size={16} /> <span className="hidden sm:inline">People</span>
          </NavLink>
        )}
        <span className="hidden max-w-[16rem] truncate text-xs text-white/70 md:inline" title={member.email}>{member.email}</span>
        <button type="button" onClick={() => void signOut()} className="flex items-center gap-1.5 rounded p-1.5 text-white/80 hover:bg-white/10 hover:text-white" title={`Sign out ${member.email}`}>
          <LogOut size={16} /><span className="hidden text-sm sm:inline">Sign out</span>
        </button>
      </header>
      <main className="min-h-0 flex-1 overflow-y-auto px-4 py-6 md:px-8">
        <div className="mx-auto w-full max-w-5xl">
          <Suspense fallback={<Spinner label="Loading" />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </div>
  );
}
